import styled from 'styled-components';

const UptimeCircleIndicator = styled.div`
  background-color: ${({ background }) => background};
  border-radius: 1.5rem;
  width: 2.5rem;
  height: 2.5rem;
  flex-grow: 0;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// `unknown` covers a status that has not been established: a failed query, or
// a location with no eligible cameras. It paints grey so the row does not read
// as an outage.
export const BinaryUptimeIndicator = ({
  status,
  unknown = false,
  title,
}: {
  status: boolean,
  unknown?: boolean,
  title?: string,
}) => {
  return (
    <Wrapper title={title}>
      <UptimeCircleIndicator
        background={
          unknown ? 'var(--mid-grey)' : status ? 'var(--ok)' : 'var(--error)'
        }
      />
    </Wrapper>
  );
};
